import {
  ChannelWorkingHoursService,
  type ChannelAvailabilityStatus
} from '@/backend/market'
import { ChannelWorkingHoursRepository } from '../../domain/repositories/ChannelWorkingHoursRepository'
import type { ChannelWorkingHoursEntity } from '../../domain/entities/ChannelWorkingHoursEntity'
import { ChannelWorkingHoursModel } from '../models/ChannelWorkingHoursModel'
import {
  toPutChannelManualStatusRequest,
  toPutChannelShiftsRequest
} from '../models/ChannelWorkingHoursRequestModel'

export class ChannelWorkingHoursRepositoryImpl extends ChannelWorkingHoursRepository {
  async get(channelId: number, regionId: number) {
    try {
      const response = await ChannelWorkingHoursService.getChannelWorkingHoursAdmin({
        channelId,
        regionId
      })
      return new ChannelWorkingHoursModel(response)
    } catch {
      return { error: true as const }
    }
  }

  async updateShifts(channelId: number, regionId: number, data: ChannelWorkingHoursEntity) {
    try {
      await ChannelWorkingHoursService.putChannelShiftsAdmin({
        channelId,
        regionId,
        requestBody: toPutChannelShiftsRequest(data.shiftDays ?? [])
      })
      return { success: true as const }
    } catch {
      return { error: true as const }
    }
  }

  async updateStatus(
    channelId: number,
    regionId: number,
    status: ChannelAvailabilityStatus,
    expiresAt: string | null
  ) {
    try {
      await ChannelWorkingHoursService.putChannelManualStatusAdmin({
        channelId,
        regionId,
        requestBody: toPutChannelManualStatusRequest(status, expiresAt)
      })
      return { success: true as const }
    } catch {
      return { error: true as const }
    }
  }
}
